import {createSlice} from "@reduxjs/toolkit";

const slice = createSlice({
        name: "auth",
        initialState: {},
        reducers: {
            auth: (state, action) => {
                state = action.payload;
                return state;
            },
            updateAuth: (state, action) => {
                state[action.payload.field_name] = action.payload.value;
                return state;
            },
            updateAuthFieldToField: (state, action) => {
                let data = action.payload;
                Object.keys(data).map((k) => {
                    state[k] = data[k];
                });
                return state;
            }
        }
    })
;

export const {auth, updateAuth, updateAuthFieldToField} = slice.actions;

export default slice.reducer;
